/**
 * /admin/sms-retention — the SMS retention panel on its own page, for admins as well as superadmins.
 * The Error Logs page (superadmin only) shows the same panel; this route exists because the
 * escalation owner is an admin and the watchdog's alert links here.
 */
import React from "react";
import SmsRetentionPanel from "../../components/admin/SmsRetentionPanel";

const SmsRetention: React.FC = () => (
  <div className="p-6 max-w-6xl mx-auto">
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-gray-900">SMS Retention</h1>
      <p className="mt-1 text-sm text-gray-500">
        Status of the nightly job that deletes old SMS message text. Refreshes
        every minute.
      </p>
    </div>
    <SmsRetentionPanel />
  </div>
);

export default SmsRetention;
